export const getEntityId = entity => entity?._id || entity?.id || null;

export const mapFeedItemToReel = item => {
  const feedItemId = getEntityId(item);
  const influencer = item.influencer || item.author || {};
  const primaryMedia = item.media?.[0];
  const mediaType = primaryMedia?.type?.toLowerCase() === 'video' ? 'video' : 'image';
  const mediaUrl = primaryMedia?.url || '';
  const thumbnailUrl = primaryMedia?.thumbnailUrl || item.thumbnailUrl || '';
  const previewUrl =
    mediaType === 'video' ? thumbnailUrl : thumbnailUrl || mediaUrl || '';

  if (!feedItemId || (!mediaUrl && !previewUrl)) {
    return null;
  }

  return {
    id: feedItemId,
    authorId: getEntityId(influencer),
    profileRouteId: influencer.telegram?.username || influencer.telegramUsername || item.authorId || null,
    name: influencer.name || item.name || influencer.username || 'Creator',
    username: influencer.username || item.username || '',
    avatar: influencer.profilePhoto || influencer.avatar || item.profilePhoto || '',
    caption: item.caption || '',
    isTrending: Boolean(item.isTrending),
    hashtags: item.hashtags || [],
    commentsAllowed: item.commentSettings?.allowed ?? item.commentsAllowed ?? true,
    isFollowing: Boolean(influencer.isFollowing ?? item.isUserSubscribed ?? item.isFollowing),
    liked: Boolean(item.liked),
    likePending: Boolean(item.likePending),
    primaryMedia: {
      type: mediaType,
      url: mediaUrl || previewUrl,
      thumbnailUrl,
      previewUrl,
    },
    stats: {
      likesCount: item.stats?.likesCount ?? 0,
      commentsCount: item.stats?.commentsCount ?? 0,
      sharesCount: item.stats?.sharesCount ?? 0,
      viewsCount: item.stats?.viewsCount ?? 0,
    },
  };
};

export const mapFeedItemsToReels = feedItems => (feedItems || []).map(mapFeedItemToReel).filter(Boolean);
